// VGNA Pro carries no advertising. VGPro placed ad slots through the match list
// and the leaderboard; the component stays so those layouts are untouched.
import React from "react";

export const Adsense = () => <React.Fragment />;
